export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11912.c832b01e.jpg";